<template>
  <div
    class="license-cards-list"
    :class="{ 'mt-lg': mtLg, 'mt-sm': mtSm, 'has-border-top': hasBorderTop }"
    :style="{ marginTop: marginTop + 'px' }"
  >
    <p v-if="title" :class="{ 'fs-small': fsSmall }" class="license-card-list_title">
      {{ title }}
    </p>
    <div v-if="subtitle" class="license-card-list_subtitle-wrap">
      <i v-if="subtitleIcon" :class="subtitleIcon" class="license-card-list_subtitle-icon" />
      <img v-if="subtitleImg" :src="subtitleImg" alt="" class="license-card-list_subtitle-img" />
      <p class="license-card-list_subtitle">
        {{ subtitle }}
      </p>
    </div>
    <div class="license-card-list_cards">
      <LicenseCard
        v-for="(license, licenseIndex) in licenseList"
        :key="licenseIndex"
        :card-content="license"
        :btn-text="btnText"
        :btn-icon="btnIcon"
        :has-btn="!hasTagNoBtn ? hasBtn : license.status ? false : true"
        :isloading="isloading"
        :blue-bottom="hasBlueBottom"
        :to="$_setTo(license.id)"
        @click="$_licenseClick(license.id)"
        @btn-click="$_licenseBtnClick()"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: 'LicenseCardList',
  props: {
    hasTagNoBtn: {
      type: Boolean,
      default: false,
    },
    licenseList: {
      type: Array,
      default() {
        return [];
      },
    },
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    subtitleIcon: {
      type: String,
      default: '',
    },
    subtitleImg: {
      type: String,
      default: '',
    },
    btnText: {
      type: String,
      default: '',
    },
    hasBtn: {
      type: Boolean,
      default: false,
    },
    btnIcon: {
      type: String,
      default: '',
    },
    mtLg: {
      type: Boolean,
      default: false,
    },
    mtSm: {
      type: Boolean,
      default: false,
    },
    to: {
      type: String,
      default: '',
    },
    isloading: {
      type: Boolean,
      default: false,
    },
    hasBlueBottom: {
      type: Boolean,
      default: false,
    },
    marginTop: {
      type: Number,
      default: 0,
    },
    hasBorderTop: {
      type: Boolean,
      default: false,
    },
    fsSmall: {
      type: Boolean,
      default: false,
    },
    query: {
      type: String,
    },
  },

  methods: {
    $_licenseClick(licenseId) {
      this.$emit('click', licenseId);
    },
    $_licenseBtnClick() {
      this.$emit('btn-click');
    },
    $_setTo(licenseId) {
      const url = `/${this.to}/${licenseId}`;
      return this.query ? `${url}?${this.query}` : url;
    },
  },
};
</script>
<style lang="scss">
@import '@/assets/scss/component/license-card-list';
</style>
